<template>
  <div class="home-hero" :class="{'home-hero--mobile': deviceType === 'mobile'}">
    <!-- 黑色背景区域 -->
    <div class="home-hero__bg">
      <img src="@/assets/hero-pattern.png" class="home-hero__bg-pattern" alt="background pattern">
    </div>

    <!-- 轮播导航点 -->
    <div class="home-hero__indicators">
      <div v-for="(car, i) in cars" :key="`indicator-${i}`"
        :class="['home-hero__indicator', { 'home-hero__indicator--active': currentIndex === i }]"
        @click="setCurrentIndex(i)"></div>
    </div>

    <!-- 主图区域 -->
    <div class="home-hero__main">
      <div class="home-hero__carousel">
        <transition-group name="fade">
          <div v-for="(car, i) in cars" :key="`slide-${i}`" v-show="currentIndex === i"
            class="home-hero__slide">
            <img :src="car.image" class="home-hero__img" alt="car image">
            <a class="home-hero__car-tag" :href="getCarDetailUrl(car)">
              <div class="home-hero__car-name">{{ car.model }}</div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="12" viewBox="0 0 24 12"
                fill="none">
                <path d="M0 5.1869H15.6573V6.92024H0V5.1869Z" class="theme-fill" />
                <path d="M15.5692 0L24 5.92L15.5692 12V0Z" class="theme-fill" />
              </svg>
            </a>
          </div>
        </transition-group>
      </div>
    </div>

    <!-- PC搜索区域 -->
    <div v-if="deviceType !== 'mobile'" class="home-hero__search" @click.stop>
      <!-- 标题区域 -->
      <div class="home-hero__title-container">
        <div class="home-hero__title-bg">
          <div class="home-hero__title">Find Your Perfect Car</div>
        </div>
        <div class="home-hero__title-line"></div>
      </div>

      <!-- 筛选器 -->
      <div class="home-hero__filters">
        <!-- 类型选择下拉框 -->
        <div class="home-hero__filter" @click.stop="toggleDropdown('type')">
          <div class="home-hero__filter-content">
            <img src="@/assets/homehero/Model.svg" class="home-hero__filter-icon" alt="model icon">
            <div class="home-hero__filter-text">{{ selectedType.name }}</div>
          </div>
          <img src="@/assets/homehero/arow-down.svg" class="home-hero__filter-arrow"
            :class="{'home-hero__filter-arrow--rotated': activeDropdown === 'type'}"
            alt="dropdown arrow">

          <!-- 类型选择下拉菜单 -->
          <div class="home-hero__dropdown" v-show="activeDropdown === 'type'">
            <div class="home-hero__dropdown-inner">
              <div v-for="(item, index) in types" :key="`type-${index}`"
                class="home-hero__dropdown-item"
                :class="{'home-hero__dropdown-item--active': selectedType.id === item.id}"
                @click.stop="selectItem('type', item)">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>

        <!-- 价格选择下拉框 -->
        <div class="home-hero__filter" @click.stop="toggleDropdown('price')">
          <div class="home-hero__filter-content">
            <img src="@/assets/homehero/Budget.svg" class="home-hero__filter-icon"
              alt="budget icon">
            <div class="home-hero__filter-text">{{ selectedPrice.name }}</div>
          </div>
          <img src="@/assets/homehero/arow-down.svg" class="home-hero__filter-arrow"
            :class="{'home-hero__filter-arrow--rotated': activeDropdown === 'price'}"
            alt="dropdown arrow">

          <!-- 价格选择下拉菜单 -->
          <div class="home-hero__dropdown" v-show="activeDropdown === 'price'">
            <div class="home-hero__dropdown-inner">
              <div v-for="(item, index) in prices" :key="`price-${index}`"
                class="home-hero__dropdown-item"
                :class="{'home-hero__dropdown-item--active': selectedPrice.id === item.id}"
                @click.stop="selectItem('price', item)">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>

        <!-- 品牌选择下拉框 -->
        <div class="home-hero__filter" @click.stop="toggleDropdown('brand')">
          <div class="home-hero__filter-content">
            <img src="@/assets/homehero/Brand.svg" class="home-hero__filter-icon" alt="brand icon">
            <div class="home-hero__filter-text">{{ selectedBrand.name }}</div>
          </div>
          <img src="@/assets/homehero/arow-down.svg" class="home-hero__filter-arrow"
            :class="{'home-hero__filter-arrow--rotated': activeDropdown === 'brand'}"
            alt="dropdown arrow">

          <!-- 品牌选择下拉菜单 -->
          <div class="home-hero__dropdown" v-show="activeDropdown === 'brand'">
            <div class="home-hero__dropdown-inner">
              <div v-for="(item, index) in brands" :key="`brand-${index}`"
                class="home-hero__dropdown-item"
                :class="{'home-hero__dropdown-item--active': selectedBrand.id === item.id}"
                @click.stop="selectItem('brand', item)">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- 搜索按钮 -->
      <a class="home-hero__search-btn" :href="searchHref">
        <img src="@/assets/search.svg" class="home-hero__search-icon" alt="search icon">
        <div class="home-hero__search-text">Search</div>
      </a>
    </div>

    <AdComponent v-if="deviceType === 'mobile' && !domainConfig?.adPlacement?.mobileHomeOrder"
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.home_1" ref="ads-home-1"
      class="ads-insert-full mobile-banner-ads" data-ad-placement="home_1" data-ad-source-placement="home_1" :ads="adsensConfig?.home_1"
      :showDebug="showDebug" />

    <CarRecommend v-if="deviceType === 'mobile' && !domainConfig?.adPlacement?.mobileHomeOrder" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AdComponent from '@/pages/components/AdComponent.vue'
import CarRecommend from '@/components/CarRecommend.vue'

export default {
  name: 'HomeHero',
  components: {
    AdComponent,
    CarRecommend
  },
  data () {
    return {
      cars: [],
      currentIndex: 0,
      autoplayTimer: null,
      loading: false,
      error: null,
      autoplayInterval: 5000,

      // CarSearch 功能数据
      activeDropdown: null, // 当前展开的下拉菜单

      // 车型类型数据
      types: [
        { id: 'all-types', name: 'All Types' },
        { id: 'Sedan', name: 'Sedan' },
        { id: 'SUV', name: 'SUV' },
        { id: 'Coupe', name: 'Coupe' },
        { id: 'Hatchback', name: 'Hatchback' },
        { id: 'Wagon', name: 'Wagon' },
        { id: 'Pickup Truck', name: 'Pickup Truck' },
        { id: 'Van', name: 'Van' },
        { id: 'Convertible', name: 'Convertible' }
      ],
      selectedType: { id: 'all-types', name: 'All Types' },

      // 价格范围数据
      prices: [
        { id: 'all-prices', name: 'All Ex-Showroom Price' },
        { id: 'less_20000', name: 'Less than $20,000' },
        { id: '20001_40000', name: '$20,001 - $40,000' },
        { id: '40001_60000', name: '$40,001 - $60,000' },
        { id: '60001_80000', name: '$60,001 - $80,000' },
        { id: 'more_80001', name: 'More than $80,000' }
      ],
      selectedPrice: { id: 'all-prices', name: 'All Ex-Showroom Price' },

      // 品牌数据
      brands: [
        { id: 'all-brands', name: 'All Brands' },
        { id: 'Acura', name: 'Acura' },
        { id: 'Alfa Romeo', name: 'Alfa Romeo' },
        { id: 'Aston Martin', name: 'Aston Martin' },
        { id: 'Audi', name: 'Audi' },
        { id: 'Bentley', name: 'Bentley' },
        { id: 'BMW', name: 'BMW' },
        { id: 'Buick', name: 'Buick' },
        { id: 'Cadillac', name: 'Cadillac' },
        { id: 'Chevrolet', name: 'Chevrolet' },
        { id: 'Chrysler', name: 'Chrysler' },
      ],
      selectedBrand: { id: 'all-brands', name: 'All Brands' }
    };
  },
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      adsensConfig: 'adsensConfig',
      showDebug: 'showDebug',
      originalTopCars: 'originalTopCars',
      topCarsLoaded: 'topCarsLoaded',
      topCarsLoadTime: 'topCarsLoadTime',
      domainConfig: 'domainConfig'
    }),
    searchHref () {
      return this.getSearchUrl();
    }
  },
  mounted () {
    // 获取推荐车辆数据并启动自动轮播
    this.fetchTopCarsIfNeeded();

    // 添加点击外部关闭下拉菜单事件
    document.addEventListener('click', this.handleOutsideClick);

    // 添加事件监听，用于其他组件请求数据
    this.$root.$on('fetch-top-cars', this.fetchTopCarsIfNeeded);
  },
  beforeDestroy () {
    // 清除轮播定时器
    this.stopAutoplay();

    // 移除点击外部事件监听
    document.removeEventListener('click', this.handleOutsideClick);

    // 移除事件监听
    this.$root.$off('fetch-top-cars', this.fetchTopCarsIfNeeded);
  },
  methods: {
    // 获取推荐车辆数据（如果需要）
    fetchTopCarsIfNeeded () {
      // 检查数据是否已加载
      if (this.topCarsLoaded && Array.isArray(this.originalTopCars) && this.originalTopCars.length > 0) {
        // 如果数据已加载，检查是否需要刷新（例如，数据超过15分钟）
        const currentTime = Date.now();
        const dataAge = currentTime - (this.topCarsLoadTime || 0);
        const maxDataAge = 15 * 60 * 1000; // 15分钟

        if (dataAge < maxDataAge) {
          // 数据足够新，直接使用
          console.log('[HomeHero] Using cached data, age:', Math.round(dataAge / 1000 / 60), 'minutes');
          this.processTopCarsData(this.originalTopCars);
          return;
        }
      }

      // 数据未加载或已过期，重新获取
      this.fetchTopCars();
    },

    // 获取推荐车辆数据
    async fetchTopCars () {
      this.loading = true;
      this.error = null;
      try {
        // 从store获取域名配置的主题过滤条件
        const themeFilters = this.$store.getters.domainConfig?.themeFilters || {};
        // 获取webIndex
        const webIndex = this.$store.getters.domainConfig?.webIndex || 1;

        // 调用global.js中的getRecommendedTopCars方法获取数据
        const params = {
          ...themeFilters,
          webIndex
        };
        const res = await this.$global.server.getRecommendedTopCars(params);
        if (res.code === 200) {
          // 获取API返回的数据
          const apiData = res.data || [];

          // 将原始数据存储到Vuex
          this.$store.commit('SET_ORIGINAL_TOP_CARS', apiData);

          // 处理数据用于本组件显示
          this.processTopCarsData(apiData);

          console.log('[HomeHero] Fetched and stored top cars:', apiData.length);
        } else {
          throw new Error(res.message || '获取推荐车辆失败');
        }
      } catch (error) {
        console.error('[HomeHero] Error fetching top cars:', error);
        this.error = error.message || '获取推荐车辆失败';

        // 重置Vuex中的加载状态
        this.$store.commit('RESET_TOP_CARS_LOADED');
      } finally {
        this.loading = false;
      }
    },

    // 处理API返回的车辆数据
    processTopCarsData (apiData) {
      try {
        // 处理API返回的数据
        const processedData = apiData.map(item => {
          // 从photos字段提取第一张图片作为封面
          const photos = item.photos ? item.photos.split(',') : [];
          const firstPhoto = photos.length > 0 ? photos[0] : require('@/assets/car-recommend-img.png');

          // 返回处理后的数据，映射字段名称
          return {
            id: item.id,
            model: item.name, // API中是name字段，映射为model
            brand: item.brand,
            logo: item.logoUrl || require('@/assets/car-logo.svg'), // 使用默认logo，因为API中没有提供
            year: item.year || item.marketTime?.substring(0, 4) || '-',
            category: item.purpose || '-', // 使用purpose字段作为category
            bodyType: item.type || '-', // 使用type字段作为bodyType
            price: this.formatPrice(item.leastPrice, item.mostPrice) || item.price || '-',
            image: item.cover || firstPhoto, // 使用cover字段，如果没有则使用firstPhoto
            speedValue: item.accelerationTime ? `${item.accelerationTime}s` : '-' // 添加's'后缀
          };
        });

        // 随机选择4辆车作为轮播展示
        this.cars = this.getRandomCars(processedData, 4);
        this.startAutoplay();

      } catch (error) {
        console.error('[HomeHero] Error processing top cars data:', error);
      }
    },

    // 随机选择指定数量的车辆
    getRandomCars (carsArray, count) {
      // 如果车辆数量不足，则直接返回所有车辆
      if (!Array.isArray(carsArray) || carsArray.length <= count) {
        return carsArray || [];
      }

      // 随机选择车辆
      const shuffled = [...carsArray].sort(() => 0.5 - Math.random());
      return shuffled.slice(0, count);
    },

    // 设置当前轮播索引
    setCurrentIndex (index) {
      this.currentIndex = index;
      // 重置自动轮播计时器
      this.restartAutoplay();
    },

    // 开始自动轮播
    startAutoplay () {
      this.autoplayTimer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.cars.length;
      }, this.autoplayInterval);
    },

    // 停止自动轮播
    stopAutoplay () {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    },

    // 重启自动轮播（用于用户交互后重新计时）
    restartAutoplay () {
      this.stopAutoplay();
      this.startAutoplay();
    },

    // 格式化价格显示
    formatPrice (leastPrice, mostPrice) {
      if (!leastPrice && !mostPrice) return null;

      const formatNumber = (num) => {
        if (!num) return null;
        // 将价格格式化为$xx,xxx格式
        return '$' + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      };

      if (leastPrice && mostPrice) {
        // 有最低价和最高价，显示价格区间
        return `${formatNumber(leastPrice)}-${formatNumber(mostPrice)}`;
      } else if (leastPrice) {
        // 只有最低价
        return `>${formatNumber(leastPrice)}`;
      } else if (mostPrice) {
        // 只有最高价
        return `<${formatNumber(mostPrice)}`;
      }

      return null;
    },

    // 生成车辆详情页的URL
    getCarDetailUrl (car) {
      try {
        if (!car || !car.id) {
          console.warn('[HomeHero] Missing car data for detail page link');
          return '#';
        }
        const currentChannel = this.$router.currentRoute.params.channel;
        const formattedName = encodeURIComponent((car.model || car.name || '').replace(/\s+/g, '-'));
        const currentQuery = { ...this.$route.query };
        const queryString = Object.keys(currentQuery).length > 0
          ? `?${new URLSearchParams(currentQuery).toString()}`
          : '';

        if (currentChannel) {
          const baseUrl = window.location.origin;
          const fullPath = `${baseUrl}/${currentChannel}/cars/${formattedName}/${car.id}${queryString}`;
          return fullPath;
        } else {
          const path = `/cars/${formattedName}/${car.id}`;
          return `${path}${queryString}`;
        }
      } catch (error) {
        console.error('[HomeHero] Detail link generation error:', error);
        return '#';
      }
    },

    // ==== 从 CarSearch.vue 复制的功能 ====

    // 处理点击组件外部事件
    handleOutsideClick (event) {
      // 如果点击的不是组件内部元素，则关闭所有下拉菜单
      if (!this.$el.contains(event.target)) {
        this.closeDropdowns();
      }
    },

    // 切换下拉菜单显示状态
    toggleDropdown (type) {
      event.stopPropagation(); // 阻止事件冒泡

      // 切换下拉菜单状态
      if (this.activeDropdown === type) {
        this.activeDropdown = null;
      } else {
        this.activeDropdown = type;
      }

      console.log('[HomeHero] 当前激活的下拉菜单:', this.activeDropdown);
    },

    // 关闭所有下拉菜单
    closeDropdowns () {
      this.activeDropdown = null;
    },

    // 选择菜单项
    selectItem (type, item) {
      switch (type) {
        case 'type':
          this.selectedType = item;
          break;
        case 'price':
          this.selectedPrice = item;
          break;
        case 'brand':
          this.selectedBrand = item;
          break;
      }

      // 阻止事件冒泡
      event.stopPropagation();

      console.log(`[HomeHero] 已选择 ${type}: `, item.name);

      // 关闭当前下拉菜单
      this.activeDropdown = null;
    },

    getSearchParams () {
      const searchParams = {};

      // 如果选择了类型，添加到搜索参数
      if (this.selectedType.id !== 'all-types') {
        searchParams.type = this.selectedType.id;
      }

      // 如果选择了价格区间，添加到搜索参数
      if (this.selectedPrice.id !== 'all-prices') {
        // 根据价格ID设置对应的价格参数
        const priceId = this.selectedPrice.id;
        switch (priceId) {
          case 'less_20000':
            searchParams.mostPrice = 20000;
            break;
          case '20001_40000':
            searchParams.leastPrice = 20001;
            searchParams.mostPrice = 40000;
            break;
          case '40001_60000':
            searchParams.leastPrice = 40001;
            searchParams.mostPrice = 60000;
            break;
          case '60001_80000':
            searchParams.leastPrice = 60001;
            searchParams.mostPrice = 80000;
            break;
          case 'more_80001':
            searchParams.leastPrice = 80001;
            break;
        }
      }

      // 如果选择了品牌，添加到搜索参数
      if (this.selectedBrand.id !== 'all-brands') {
        searchParams.brand = this.selectedBrand.id;
      }

      return searchParams;
    },
    getSearchUrl () {
      const searchParams = this.getSearchParams();
      const currentQuery = { ...this.$route.query };
      const finalQuery = { ...currentQuery, ...searchParams };
      const queryString = new URLSearchParams(finalQuery).toString();
      const fullQueryString = queryString ? `?${queryString}` : '';
      const channelPath = this.$route.params.channel ? `/${this.$route.params.channel}/car-list` : '/car-list';
      return `${channelPath}${fullQueryString}`;
    },

    // 保留给旧调用；真实点击入口已改为 a[href]。
    searchWithParams () {
      window.location.href = this.getSearchUrl();
    }
  }
};
</script>

<style lang="scss">
@import '~@/css/hero.scss';

// 新增样式，适配CarSearch功能
.home-hero {
	&__filter {
		position: relative; // 添加相对定位，作为下拉菜单的定位父元素
	}

	&__dropdown {
		position: absolute;
		top: 100%; // 放在父元素底部
		left: 0;
		width: 100%;
		background: #ffffff;
		border-radius: rem(8);
		box-shadow: 0 rem(2) rem(8) rgba(0, 0, 0, 0.16);
		z-index: 20; // 提高z-index确保在其他元素之上
		max-height: rem(300);
		overflow-y: auto;
		margin-top: rem(8);
		&::-webkit-scrollbar {
			display: none; /* Chrome Safari */
		}
	}

	&__dropdown-inner {
		display: flex;
		flex-direction: column;
		width: 100%;
	}

	&__dropdown-item {
		padding: rem(14) rem(20);
		color: #141414;
		font-size: rem(14);
		line-height: rem(14);
		font-weight: 400;
		border-bottom: rem(1) solid #f3f3f3;
		cursor: pointer;

		&:last-child {
			border-bottom: none;
		}

		&:hover {
			background: rgba(var(--theme-color-r), var(--theme-color-g), var(--theme-color-b), 0.05);
		}

		&--active {
			color: var(--theme-color);
			font-weight: 500;
		}
	}

	&__filter-arrow {
		&--rotated {
			transform: rotate(180deg);
		}
		transition: transform 0.3s ease;
	}

	// 移动端样式
	&--mobile {
		height: auto;
		padding-top: rem(328);

		.home-hero__bg {
			border-radius: 0 0 rem(36) 0;
			height: 100%;
			z-index: 1;
		}

		.home-hero__indicators {
			left: rem(16);
			top: rem(298);
			bottom: auto;
			gap: rem(8);
		}
		.home-hero__indicator {
			background: #ffffff;
		}
		.home-hero__indicator--active {
			background: var(--theme-color);
		}

		.home-hero__main {
			width: 100%;
			height: rem(210);
			top: rem(72);
			right: 0;
			z-index: 2;
		}

		.home-hero__img {
			border-radius: rem(36) 0 0 0;
		}

		.home-hero__car-tag {
			right: rem(12);
			bottom: rem(12);
			background: #141414;
			border-radius: rem(12);
			padding: rem(6) rem(20);
		}
	}

	// 移动端搜索区域
	&__search-mobile {
		padding: rem(0) rem(16) rem(52) rem(16);
		display: flex;
		flex-direction: column;
		gap: rem(40);
		align-items: flex-start;
		justify-content: flex-start;
		width: 100%;
		position: relative;
	}

	&__title-container-mobile {
		display: flex;
		flex-direction: column;
		gap: rem(16);
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		width: 100%;
	}

	&__title-bg-mobile {
		// background: rgba(20, 20, 20, 0.2);
		border-radius: 0 0 rem(24) 0;
		padding: rem(20) rem(20) rem(20) 0;
		display: flex;
		width: 100%;
	}

	&__title-mobile {
		// color: #ffffff;
		font-size: rem(48);
		line-height: rem(48);
		font-weight: 900;
		width: 100%;
	}

	&__title-line-mobile {
		background: var(--theme-color);
		border-radius: rem(100);
		width: rem(48);
		height: rem(4);
	}

	&__filters-mobile {
		display: flex;
		flex-direction: column;
		gap: rem(16);
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		width: 100%;
	}

	&__filter-mobile {
		background: #ffffff;
		border-radius: rem(12);
		padding: rem(16) rem(20);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		width: 100%;
		position: relative;
		cursor: pointer;
	}

	&__filter-content-mobile {
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
	}

	&__filter-icon-mobile {
		width: rem(16);
		height: rem(16);
	}

	&__filter-text-mobile {
		color: #141414;
		font-size: rem(14);
		line-height: rem(14);
		font-weight: 400;
	}

	&__filter-arrow-mobile {
		width: rem(16);
		height: rem(16);
		transition: transform 0.3s ease;
	}

	&__dropdown-mobile {
		position: absolute;
		top: 100%;
		left: 0;
		width: 100%;
		background: #ffffff;
		border-radius: rem(8);
		box-shadow: 0 rem(2) rem(8) rgba(0, 0, 0, 0.16);
		z-index: 20;
		max-height: rem(200);
		overflow-y: auto;
		margin-top: rem(4);
		&::-webkit-scrollbar {
			display: none;
		}
	}

	&__search-btn-mobile {
		background: var(--theme-color);
		border-radius: rem(12);
		padding: rem(14) rem(40);
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: center;
		align-self: stretch;
		width: 100%;
		cursor: pointer;
	}

	&__search-icon-mobile {
		width: rem(20);
		height: rem(20);
	}

	&__search-text-mobile {
		color: #ffffff;
		font-size: rem(20);
		line-height: rem(20);
		font-weight: 500;
	}
}
.home-hero--mobile{
  flex-direction: column;
}
.detect_deviece_mobile {
	.home-hero {
		&__bg {
			width: 100%;
		}
	}
	.mobile-banner-ads {
		position: relative;
		z-index: 99;
    padding: 0 rem(16);
	}
}
</style>
